import { Link } from 'react-scroll';
import styled from 'styled-components';

export const ScrollStyled = styled(Link)`
  cursor: pointer;
`;